import {transient} from 'quickstart/system'
import {Variant} from 'quickstart/theme/base/typography'
import {UnprefixTransientProps} from 'quickstart/types'
import {ComponentProps, forwardRef} from 'react'
import * as S from './styles'

type TextProps = Partial<
  UnprefixTransientProps<ComponentProps<typeof S.Text>>
> & {
  prose?: boolean // shortcut sets rhythm and font
  ui?: never // disused since Prose component
}

const HEADING_TAGS = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  sectionHead: 'h2',
  sectionHeadTight: 'h2',
} as {
  [k in Variant]: keyof JSX.IntrinsicElements
}

const TAGS = HEADING_TAGS

export const Text = forwardRef<any, TextProps>(
  (
    {
      prose = false,
      rhythm = prose ? 'prose' : undefined,
      variant = 'textMd' as Variant,
      as = TAGS[variant],
      proseFont = variant in HEADING_TAGS ? 'heading' : 'body',
      font = prose || variant in HEADING_TAGS ? proseFont : undefined,
      bold,
      italic,
      underline,
      lines,
      ...props
    },
    ref,
  ) => (
    <S.Text
      ref={ref}
      as={as}
      {...transient({
        variant,
        proseFont,
        font,
        rhythm,
        bold,
        italic,
        underline,
        lines,
      })}
      {...props}
    />
  ),
)

export {Prose} from './styles'
